import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from '@angular/core';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { APP_CONFIG } from '../../../app.config';
import {
    AuthService,
    scrollToTop,
    SpinnerService,
} from '@gallaghercp/core-frontend';
import { ClientService } from '../../../services/client.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
    selector: 'core-manual-login',
    templateUrl: './login.component.html',
    standalone: false,
})
export class ManualLoginComponent implements OnInit, AfterViewInit {
    @ViewChild('captchaRef') recaptchaRef!: RecaptchaComponent;
    @ViewChild('accessCode') accessCodeInput!: ElementRef;

    currentYear: number = new Date().getFullYear();

    loading!: boolean;
    errorMessage!: string | boolean;

    loginForm = new FormGroup({
        accessCode: new FormControl('', [
            Validators.required,
            Validators.minLength(32),
            Validators.maxLength(32),
        ]),
    });

    copyright = APP_CONFIG.copyright;

    constructor(
        protected auth: AuthService,
        protected spinner: SpinnerService,
        public client: ClientService,
        protected router: Router,
        protected titleService: Title
    ) {}

    login(captchaResponse: string) {
        this.loading = true;
        this.errorMessage = false;
        this.spinner.show('login');

        return this.auth
            .login(
                Date.now() + '@valuesyou.com',
                this.loginForm.get('accessCode')!.value as string,
                captchaResponse
            )
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    scrollToTop(500);
                    this.spinner.hide('login');
                    this.loading = false;
                    this.recaptchaRef.reset();
                    this.errorMessage = `<p>Error reference: ${error.headers.get(
                        'x-service-request-id'
                    )}</p>`;

                    return throwError(
                        `Error Code: ${error.status}\nMessage: ${error.message}`
                    );
                })
            )
            .subscribe(() => {
                this.spinner.show('login');
                this.loading = true;
            });
    }

    ngOnInit() {
        this.titleService.setTitle('Login | ' + APP_CONFIG.appName);
        this.auth.validateAuthentication().subscribe(() => {
            if (this.auth.isAuthenticated()) {
                this.router.navigate(['/']);
            }
        });
    }

    ngAfterViewInit() {
        this.accessCodeInput.nativeElement.focus();
    }
}
